module.exports = __webpack_public_path__ + "img/3.feac344c.png";